<div class="email-modal" [class.preview-mode]="isPreviewMode">
  <header class="modal-header">
    <h2>Compose birthday email</h2>
    <button class="icon-close" type="button" (click)="close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  @if (!isPreviewMode) {
  <section class="modal-body compose-body">
    <mat-form-field class="field-block" appearance="outline">
      <mat-label>From</mat-label>
      <input matInput type="text" [(ngModel)]="emailMessage.from.email" disabled="true" />
    </mat-form-field>

    <mat-form-field class="field-block" appearance="outline">
      <mat-label>To</mat-label>
      <input matInput type="text" [(ngModel)]="emailMessage.toRecipients[0].email" disabled="true" />
    </mat-form-field>

    <div class="schedule-row">
      <div class="label">Schedule email</div>
      <mat-slide-toggle [(ngModel)]="scheduleEmail"></mat-slide-toggle>
    </div>

    @if (scheduleEmail) {
    <div class="schedule-options">
      <mat-form-field appearance="outline">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="datePicker" [(ngModel)]="scheduleDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix
          [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Pick a time</mat-label>
        <input matInput [matTimepicker]="timePicker" [(ngModel)]="scheduleTime">
        <mat-timepicker-toggle matIconSuffix [for]="timePicker" />
        <mat-timepicker #timePicker />
      </mat-form-field>
    </div>
    }

    <div class="card-options" role="radiogroup" aria-label="Card design">
      @for (option of bannerOptions; track option.id) {
      <button type="button"
        class="card-option" [class.active]="selectedDesign === option.id"
        [attr.aria-label]="option.ariaLabel"
        (click)="selectedDesign = option.id">
        <img class="card-image" [src]="option.imagePath"
          [alt]="option.ariaLabel" />
      </button>
      }
    </div>

    <div class="language-row">
      <span class="label">Language:</span>
      <mat-radio-group class="language-group" [(ngModel)]="selectedLanguage" (change)="onLanguageChange()">
        @for (language of languageOptions; track language.code) {
        <mat-radio-button [value]="language.code">
          {{ language.label }}
        </mat-radio-button>
        }
      </mat-radio-group>
    </div>

    <mat-form-field class="field-block" appearance="outline">
      <mat-label>Subject</mat-label>
      <input matInput type="text" [(ngModel)]="emailMessage.subject" />
    </mat-form-field>

    <mat-form-field class="field-block" appearance="outline">
      <mat-label>Message</mat-label>
      <textarea matInput rows="7" [(ngModel)]="emailMessage.body"></textarea>
    </mat-form-field>
  </section>
  }

  @if (isPreviewMode) {
  <section class="modal-body preview-body">
    <div class="preview-banner">
      <img class="preview-image" [src]="selectedBannerImagePath"
        alt="Selected birthday card design" />
    </div>

    <div class="preview-copy">
      <p class="message-copy">{{ emailMessage.body }}</p>
    </div>
  </section>
  }

  <footer class="modal-footer">
    @if (!isPreviewMode) {
    <button type="button" class="text-action" (click)="openPreview()">
      Preview
    </button>
    } @else {
    <button type="button" class="text-action" (click)="returnToCompose()">
      Back
    </button>
    }

    <button type="button" class="pill-action"
      (click)="sendEmail()">Send</button>
  </footer>
</div>